import DataTable from "react-data-table-component";
import DatosSocio from "../../generico/DatosSocio";
import Titulo from "../../generico/TituloPagina";
import Select from "react-select";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faDownload } from "@fortawesome/free-solid-svg-icons";
import authService from "../../../services/login/auth.service";
import { trackPromise } from "react-promise-tracker";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import Popup from "react-popup";
import PagoServicioServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";


const Table = ({ columns, data }) => {

  const paginationOptions = {
    rangeSeparatorText: "de",
    noRowsPerPage: true,
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header">
            <DatosSocio />
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-12" id="comprobantes">
                <div className="table-responsive">
                  <DataTable
                    noHeader={true}
                    pagination={true}
                    columns={columns}
                    data={data}
                    dense={true}
                    striped={true}
                    paginationComponentOptions={paginationOptions}
                    noDataComponent="no hay registros para mostrar"
                  // expandableRows
                  // expandableRowsComponent={DetalleFila}
                  // expandableRowsComponent={
                  //   <DetalleFila data={this.state.listaTransferencia} />
                  // }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const PagoServicioCabalComprobante = () => {

  const [listaPeriodo, setListaPeriodo] = useState([]);
  const [periodoSeleccionado, setPeriodoSeleccionado] = useState();
  const [listaComprobantes, setListaComprobantes] = useState([]);

  useEffect(() => {
    obtenerPeriodo();
  }, []);

  const notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  const obtenerPeriodo = () => {
    var lista = [];
    lista.push({
      value: null,
      label: "--Seleccione--",
    });

    var now = new Date();
    var mes = now.getMonth() + 1;
    var anio = now.getFullYear();

    var mesChar = "";
    for (var i = 0; i < 12; i++) {
      if (mes === 0) {
        mes = 12;
        anio = anio - 1;
      }
      mesChar = mes.toString().length === 1 ? "0" + mes : mes;
      lista.push({
        value: mesChar + "/" + anio,
        label: mesChar + "/" + anio,
      });
      mes = mes - 1;
    }
    setListaPeriodo(lista);
  };

  const handleChangeSelector = (selectedOption) => {
    console.log({ selectedOption })
    if (!selectedOption?.value) setListaComprobantes([]);
    setPeriodoSeleccionado(selectedOption?.value)
  };

  const obtenerListaComprobantes = () => {

    if (periodoSeleccionado === null) {
      setListaComprobantes([]);
      return;
    }

    const [mes, anho] = periodoSeleccionado.split("/");
    const data = { cedula: authService.getCurrentUser().cedulaIdentidad, mes, anho };

    trackPromise(
      PagoServicioServiceV2.listarComprobantes(data)
        .then((response) => {

          console.log({ response })

          const { datos, mensaje, codigo } = response.data;

          if (codigo !== 0) {
            Popup.queue(notifiPopup("Info", mensaje));
            return;
          }

          const newListaComprobantes = datos.map((dato) => ({
            ...dato,
            importe: `${formatoSeparadorMilesValue(dato.importe)} ${dato.idMoneda}`
          }))

          setListaComprobantes(newListaComprobantes);
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  };

  const COLUMNS = [
    {
      name: "Fecha",
      selector: row => row.fechaOperacion,
    },
    {
      name: "Operación",
      selector: row => row.nroOperacion,
      width: "80px",
      omit: true,
    },
    {
      name: "Cuenta Débito",
      selector: row => row.cuentaOrigen,
      width: "90px",
      omit: true,
    },
    {
      name: "Entidad",
      selector: row => row.entidad,
    },
    {
      name: "Servicio",
      selector: row => row.servicio,
      width: "190px",
    },
    {
      name: "Importe",
      selector: row => row.importe,
      right: true,
    },
    {
      cell: (row) => (
        <div>
          <button
            id={"imprimir_" + row.nroOperacion}
            key={row.nroOperacion}
            className="btn btn-xs btn-outline-success"
            value={row.nroOperacion}
            onClick={() => descargarComprobante(row)}
          >
            <FontAwesomeIcon icon={faDownload} /> <b>Descargar</b>
          </button>
        </div>
      ),
      width: "120px",
    },
  ];

  const descargarComprobante = (data) => {

    console.log({ data });

    const { titularOrigen, fechaOperacion, nroOperacion, tipoCuentaDebito, cuentaOrigen, entidad, servicio, importe, idMoneda, detalleServicio } = data;

    const detalles = [
      { concepto: "Fecha de operación", valor: fechaOperacion },
      { concepto: "Entidad", valor: entidad },
      { concepto: "Servicio", valor: servicio },
      { concepto: "Importe", valor: `${formatoSeparadorMilesValue(importe)} ${idMoneda}` },
    ];

    const detalleComprobante = {
      titulo: "Pago de Servicios Cabal",
      nroSocioTitular: titularOrigen,
      nroOperacion: nroOperacion,
      formaPago: tipoCuentaDebito,
      cuentaDebito: cuentaOrigen,
    };

    if (!detalleServicio) {
      detalleComprobante.detalles = detalles;
    } else {
      const detalleServicioData = JSON.parse(detalleServicio);
      if (detalleServicioData.length > 0) {
        detalleComprobante.detalles = [
          ...detalleServicioData,
          { concepto: "Fecha de operación", valor: fechaOperacion }
        ];
      }else{
        detalleComprobante.detalles = detalles;
      }
    }

    trackPromise(
      PagoServicioServiceV2.descargarComprobante(detalleComprobante)
        .then((response) => {
          console.log('EXITO');
          console.log(response);
          let fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

  }

  return (

    <div className="content-wrapper">
      <Titulo texto="Pagos Servicios Cabal - Comprobante" />
      <section className="content">
        <div className="container">
          <div className="row">
            <div className="col-md-12" style={{ zIndex: 1 }}>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <label className="input-label-bold">Mes *</label>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <Select
                          required="true"
                          placeholder="-- Seleccione --"
                          onChange={handleChangeSelector}
                          options={listaPeriodo}
                          isClearable
                          noOptionsMessage={() => "SIN DATOS"}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <button
                        className="btn btn-cu-primary"
                        onClick={obtenerListaComprobantes}
                      >
                        <FontAwesomeIcon icon={faCheck} /> Consultar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Table columns={COLUMNS} data={listaComprobantes} />
        </div>
      </section>
    </div>


  )
}